<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CreateEditPage
  Reason: CRUD component template for creating and editing SmSigningProcess entities.
-->
@if (objectId) {
    <!-- AI: CRUD Object Component for SmSigningProcess editing -->
    <mvs-crud-object
        [objectType]="objectType"
        [objectId]="objectId"
        (onChangedObject)="handleChanged($event)"
        (onFormDirty)="onFormDirty($event)">
    </mvs-crud-object>
} @else {
    <!-- AI: CRUD Object Component for SmSigningProcess creation -->
    <mvs-crud-object
        [objectType]="objectType"
        (onChangedObject)="handleChanged($event)"
        (onFormDirty)="onFormDirty($event)">
    </mvs-crud-object>
}
